import React from 'react';
export const imagesExt = ['ai', 'ico', 'svg', 'psd', 'ps', 'tif', 'tiff', 'png', 'bmp', 'jpg', 'jpeg', 'gif'];
export const audioExt = ['aif', 'cda', 'mid', 'mp3', 'mpa', 'ogg', 'wav', 'wma', 'wpl'];
export const videosExt = ['mp4', '3g2', '3gp', 'avi', 'flv', 'h264', 'm4v', 'mkv', 'mov', 'mpg', 'mpeg', 'rm', 'swf', 'vob', 'wmv'];
export const spreadsheetsExt = ['ods', 'xls', 'xlsm', 'xlsx'];

const FilePreview = ({
  types,
  filename
}) => {
  const type = filename.split('.').pop() || "no-file";
  return /*#__PURE__*/React.createElement(React.Fragment, null, 'image' in types && imagesExt.includes(type) ? types.image : 'video' in types && videosExt.includes(type) ? types.video : 'spreadsheet' in types && spreadsheetsExt.includes(type) ? types.spreadsheet : Object.keys(types).reduce((result, key, _, array) => {
    if (key.includes(type)) {
      array.splice(0);
      return types[key];
    }

    return result;
  }, null) || types.default);
};

export default FilePreview;